module.exports = __webpack_public_path__ + "img/wenet.9a9cba56.png";